import React, { useState, useEffect } from 'react';

const StatisticsTabs = ({ tabs = [], activeTab, onTabChange }) => {
  const [internalActive, setInternalActive] = useState(tabs?.[0]?.id || null);

  const current = activeTab ?? internalActive;

  useEffect(() => {
    if (!activeTab && !internalActive && tabs?.length > 0) {
      setInternalActive(tabs[0].id);
    }
  }, [activeTab, internalActive, tabs]);

  const handleChange = (id) => {
    if (onTabChange) onTabChange(id);
    if (activeTab === undefined) setInternalActive(id);
  };

  const activeContent = tabs.find(t => t.id === current)?.content || tabs[0]?.content || null;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
      <div className="border-b border-gray-200 dark:border-gray-700 overflow-x-auto overflow-y-hidden">
        <nav className="flex -mb-px min-w-max" aria-label="Tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => handleChange(tab.id)}
              className={`flex items-center px-2 sm:px-4 py-2 sm:py-3 text-xs sm:text-sm font-medium border-b-2 whitespace-nowrap ${
                current === tab.id
                  ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
              }`}
            >
              {tab.icon && (
                <span className="mr-2 hidden sm:inline-flex items-center" aria-hidden>
                  {tab.icon}
                </span>
              )}
              <span>{tab.label}</span>
            </button>
          ))}
        </nav>
      </div>

      <div className="sm:p-4">
        {activeContent}
      </div>
    </div>
  );
};

export default StatisticsTabs;


